var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.customClasses},[_c('fonts-cmp'),_c('style-cmp'),_c('header-cmp'),_c('div',{staticClass:"main-content"},[_c('router-view')],1),_c('footer-cmp'),_c('scripts-cmp')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }